<template>
  <div>
    <transition name="fade">
      <router-view />
    </transition>
  </div>
</template>

<script>

import defaultQuestions from './config.js'
import Question from './views/Question'
import store from './store/index'
import router from './router'
export default {
  data () {
    return {
      userData: null,
      transitionName: 'fade'
    }
  },
  computed: {
    realQuestions () {
      if (this.questions == null) {
        return defaultQuestions
      } else {
        return this.questions
      }
    },
    usersData () {
      return this.$store.state.userData
    }
  },
  created () {
    this.$store.commit('setQuestions', this.realQuestions)
    this.$store.commit('setApiUrl', this.apiUrl)
    const routes = this.realQuestions.map((question, index) => {
      return {
        path: question.path,
        component: Question,
        props: (route) => {
          return {
            question: question.question,
            help: question.help,
            conditions: question.conditions,
            model: question.model,
            nextRoutePath: question.nextRoutePath,
            path: question.path,
            showNextButton: question.showNextButton,
            key: 'question-' + index
          }
        }
      }
    })

    this.$router.addRoutes(routes)
  },
  props: ['questions', 'api-url'],
  store: store,
  router
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
